export enum AfterSignStep {
  Feedback = 'feedback',
  FeedbackComplete = 'feedbackComplete',
  Signup = 'signup',
  SignupComplete = 'signupComplete',
  Init = 'init',
}
